"use client";
import { useState, useEffect } from "react";
import "./PRmanager.css";
import Cards from "./Cards";
import { Link, useNavigate } from "react-router-dom";
import Instance from "../../Utils/Axios";
import PRtable from "./PRtable";
import PremiumLoader from "../Loader/PremiumLoader";
import { BuyPrModal } from "../Modal/customModal";
import { showToast } from "../../Utils/index";

import useDashboardStore from "../../store/dashboardStore";

export default function PRlayout() {
  const navigate = useNavigate();
  const [cardData, setCardData] = useState(null);
  const { activePackageCount, fetchDashboardData } = useDashboardStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showBuyModal, setShowBuyModal] = useState(false);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchQuery(value);
    if (!value) {
      setSearchKeyword("");
    }
  };

  const handleSearchSubmit = () => {
    setSearchKeyword(searchQuery);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchSubmit();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await fetchDashboardData();
        setError("");
      } catch (err) {
        const errorMsg = err.response?.data?.resMessage || err.response?.data?.message || "Failed to fetch the details";
        setError(errorMsg);
        console.error("failed to fetch details", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fetchDashboardData]);

  const handleProtectedSubmit = (e) => {
    e.preventDefault();
    if (activePackageCount === 0) {
      showToast(
        "You don’t have an active credit or package!",
        "danger",
        "error"
      );
      setShowBuyModal(true);
    } else {
      navigate("/customer/submit-pr");
    }
  };


  return (
    <>
      <Cards cardData={cardData} />
      <div className="my_press">
        <h4 className="my_press_text">My Press Releases</h4>
        <div className="my_press_btns">
          <div className="search-bar">
            <input
              type="search"
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyDown}
              placeholder="Search PR"
            />
            <img
              src="/build/img/search.svg"
              alt="search"
              width={20}
              height={20}
              style={{ cursor: "pointer" }}
              onClick={handleSearchSubmit}
            />
          </div>
          <div onClick={handleProtectedSubmit} style={{ cursor: "pointer" }}>
            <button className="my_add_btn">
              <img
                className={"pr_add_img mb-0"}
                src="/build/img/Icons/Vector.png"
                alt="zex pr wire Logo"
                width={13}
                height={13}
              />
              Add new
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <PremiumLoader fullPage={false} text="Fetching your dashboard..." />
      ) : (
        <PRtable status="" filterQuery={searchKeyword} onStatsFetch={setCardData} />
      )}

      <BuyPrModal
        show={showBuyModal}
        onClose={() => setShowBuyModal(false)}
        onClick={() => {
          setShowBuyModal(false);
          navigate("/customer/pricing");
        }}
        title="You don’t have an active credit or package!"
        message="Buy a PR credit and start your PR campaign to reach millions of new users."
        primaryBtn="Buy PR Credit"
        icon="/build/img/Package.svg"
      />
    </>
  );
}
